export default __webpack_public_path__ + "media/siteware_admin/favicon-57-9818e82ab5317fd4eaa3ee081a6cd26f.png";